export const Header: React.FC<{ onStartTour: () => void }> = ({
  onStartTour,
}) => {
  return (
    <header className="bg-white px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
       
          <div>
            <h1 className="text-[20px] font-bold text-[#464646] bg-clip-text">
        Getting Started. Your workspace, your way.
            </h1>
            <p className="text-sm text-slate-500">
  Choose a default workspace to get started. Change it anytime on your dashboard.
            </p>
          </div>
        </div>
        <button
          onClick={onStartTour}
          className="flex items-center gap-2 px-4 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
        >
     <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 2C36.1503 2 46 11.8497 46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24C2 11.8497 11.8497 2 24 2Z" fill="#5932EA"/>
<path d="M26.4444 31.3333L33.7778 24M33.7778 24L26.4444 16.6667M33.7778 24H14.2222M46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46C36.1503 46 46 36.1503 46 24Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

        </button>
      </div>
    </header>
  );
};
